export default __webpack_public_path__ + "assets/images/11.f11eb0.webp";